import { CourierType } from 'const/CourierType';
import { PartitionType } from 'const/PartitionType';
import { getAuthHeadersFromCookie } from 'lib/AuthClient/cookie';
import { settings } from 'settings';
import Swal from 'sweetalert2';

const errorMessage = (html: string) => {
  Swal.fire({
    position: 'center',
    icon: 'error',
    title: 'There was an error',
    showConfirmButton: false,
    timer: 1500,
    html,
  });
};

export const fetchPartitioningCourier = async (
  date: string,
  region: string
) => {
  const regionPath = region.toLowerCase();
  const fetchRes = await fetch(
    `${settings.autobundlerUrl}/api/partitioning/${regionPath}/${date}/couriers`,
    {
      headers: {
        Authorization: getAuthHeadersFromCookie()?.Authorization,
      },
    }
  );

  let newCouriers: Array<CourierType> = [];
  if (fetchRes.ok) {
    newCouriers = await fetchRes.json();
  } else {
    errorMessage(`<div>Failed to fetch couriers</div>`);
  }

  return newCouriers;
};

export const fetchPartitioningList = async (date: string, region: string) => {
  const regionPath = region.toLowerCase();
  const fetchRes = await fetch(
    `${settings.autobundlerUrl}/api/partitioning/${regionPath}/${date}/partitions`,
    {
      headers: {
        Authorization: getAuthHeadersFromCookie()?.Authorization,
      },
    }
  );

  let newPartitions: Array<PartitionType> = [];

  if (fetchRes.ok) {
    const response = await fetchRes.json();
    newPartitions = response.partitions;
  } else {
    errorMessage(`<div>Failed to fetch partitions</div>`);
  }

  return newPartitions;
};

export const fetchPartitioningZoneCount = async (
  date: string,
  region: string
) => {
  const regionPath = region.toLowerCase();
  const fetchRes = await fetch(
    `${settings.autobundlerUrl}/api/partitioning/${regionPath}/${date}/counts`,
    {
      headers: {
        Authorization: getAuthHeadersFromCookie()?.Authorization,
      },
    }
  );

  let newZonePartitions: Record<string, number> = {};
  if (fetchRes.ok) {
    newZonePartitions = await fetchRes.json();
  } else {
    errorMessage(`<div>Failed to fetch zones</div>`);
  }

  return newZonePartitions;
};
